export default __webpack_public_path__ + "static/media/Developer_HeroImage.ffa4d5d0.png";